import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75141eed"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex", "aria-disabled", "onKeydown", "onDragenter", "onDragleave", "onDrop"]
const _hoisted_2 = ["multiple", "disabled"]
const _hoisted_3 = {
  key: 0,
  class: "document-upload-zone__error",
  role: "alert"
}

import { ref } from "vue";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  multiple: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
},
  emits: ["files-selected"],
  setup(__props, { emit }: { emit: ({
  (event: "files-selected", files: File[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const MAX_FILE_SIZE = 20 * 1024 * 1024;
const ALLOWED_EXTENSIONS = new Set(["pdf", "doc", "docx"]);





const fileInput = ref<HTMLInputElement | null>(null);
const isDragging = ref(false);
const validationError = ref("");
const dragDepth = ref(0);
const acceptedFileTypes =
  ".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";

function openFilePicker() {
  if (!fileInput.value || fileInput.value.disabled) return;
  validationError.value = "";
  fileInput.value.click();
}

function onInputChange(event: Event) {
  const input = event.target as HTMLInputElement;
  validateAndEmit(Array.from(input.files || []));
  input.value = "";
}

function onDragEnter() {
  if (!fileInput.value?.disabled) {
    dragDepth.value += 1;
    isDragging.value = true;
  }
}

function onDragLeave() {
  dragDepth.value = Math.max(0, dragDepth.value - 1);
  isDragging.value = dragDepth.value > 0;
}

function onDrop(event: DragEvent) {
  dragDepth.value = 0;
  isDragging.value = false;
  if (fileInput.value?.disabled) return;
  validateAndEmit(Array.from(event.dataTransfer?.files || []));
}

function validateAndEmit(files: File[]) {
  validationError.value = "";
  if (!files.length) return;

  const filesToValidate = props.multiple ? files : files.slice(0, 1);
  const selectedFiles = filesToValidate.filter((file) => {
    const extension = file.name.includes(".")
      ? file.name.split(".").pop()?.toLowerCase() || ""
      : "";
    if (!ALLOWED_EXTENSIONS.has(extension)) {
      if (!validationError.value) {
        validationError.value = t("documentUpload.unsupportedType").replace(
          "{name}",
          file.name
        );
      }
      return false;
    }
    if (file.size === 0) {
      if (!validationError.value) {
        validationError.value = t("documentUpload.emptyFile").replace(
          "{name}",
          file.name
        );
      }
      return false;
    }
    if (file.size > MAX_FILE_SIZE) {
      if (!validationError.value) {
        validationError.value = t("documentUpload.fileTooLarge").replace(
          "{name}",
          file.name
        );
      }
      return false;
    }
    return true;
  });

  if (selectedFiles.length) {
    emit("files-selected", selectedFiles);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["document-upload-zone", {
        'document-upload-zone--dragging': isDragging.value,
        'document-upload-zone--disabled': __props.disabled,
      }]),
      role: "button",
      tabindex: __props.disabled ? -1 : 0,
      "aria-disabled": __props.disabled,
      onClick: openFilePicker,
      onKeydown: [
        _withKeys(_withModifiers(openFilePicker, ["prevent"]), ["enter"]),
        _withKeys(_withModifiers(openFilePicker, ["prevent"]), ["space"])
      ],
      onDragenter: _withModifiers(onDragEnter, ["prevent"]),
      onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      onDragleave: _withModifiers(onDragLeave, ["prevent"]),
      onDrop: _withModifiers(onDrop, ["prevent"])
    }, [
      _createElementVNode("strong", null, _toDisplayString(__props.multiple
            ? _unref(t)("documentUpload.selectMultiple")
            : _unref(t)("documentUpload.selectSingle")), 1),
      _createElementVNode("small", null, _toDisplayString(_unref(t)("documentUpload.requirements")), 1),
      _createElementVNode("input", {
        ref: (_value, _refs) => {
          _refs['fileInput'] = _value
          fileInput.value = _value
        },
        type: "file",
        multiple: __props.multiple,
        accept: acceptedFileTypes,
        disabled: __props.disabled,
        hidden: "",
        onChange: onInputChange
      }, null, 40, _hoisted_2)
    ], 42, _hoisted_1),
    (validationError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(validationError.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})